import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  galleryList: [],
  galleryDetail: [],
  loading: false,
  error: undefined,
};

const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchGalleryList(state, action) {
      state.galleryList = action.payload;
      state.loading = false;
    },
    fetchGalleryDetail(state, action) {
      state.galleryDetail = action.payload;
      state.loading = false;
    },
  },
});

export const galleryActions = gallerySlice.actions;

export default gallerySlice.reducer;
